import { IPremiership, ILeagueContestants, IInstantChallenger, IMatchMaker, IChallenge } from "../../typings/typings";
import { League } from "./League";

export class Premiership extends League implements IPremiership {
    public contestants: ILeagueContestants;
    public instantChallenger: IInstantChallenger;
    public matchmaker: IMatchMaker;
    public challenge: IChallenge;
    public state: string;
    public upcomingMatchesStates;

    public timeline;

    constructor(jsonData) {
        super(jsonData);
        this.contestants = jsonData.contestants;
        this.instantChallenger = jsonData.instantChallenger;
        this.matchmaker = jsonData.matchmaker;
        this.challenge = jsonData.challenge;
        this.timeline = jsonData.timeline;
        this.state = jsonData.state;
        this.upcomingMatchesStates = { open: 100, challenge: 100, protest: 0 };
    }

    public getUrlByTemplate(template: string, $filter, $scope) {
        switch (template) {
            case "Header":
                return $filter("sprintf")($scope.templateUrls.templateHeaderUrl, "premiership");
            case "Information":
                return $filter("sprintf")($scope.templateUrls.templateInformationUrl, "premiership");
            case "UserAction":
                return $filter("sprintf")($scope.templateUrls.templateUserActionUrl, "premiership");
            case "Match":
                return $filter("sprintf")($scope.templateUrls.templateMatchUrl, "premiership");
            case "Result":
                return $filter("sprintf")($scope.templateUrls.templateResultUrl, "premiership");
            default:
                return super.getUrlByTemplate(template, $filter, $scope);
        }
    }

    public isFull() {
        if (
            typeof this.contestants !== "object" ||
            isNaN(this.contestants.max) ||
            this.contestants.max === null ||
            this.contestants.max === 0
        ) {
            return false;
        }
        return this.contestants.checkedIn >= this.contestants.max;
    }

    public isCheckInAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("checkIn");
    }

    public isSignUpAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("signUp") && this.timeline.signUp.begin;
    }

    public isPostSignUpAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("postSignUp");
    }

    public hasLateSignUp() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("lateSignUp");
    }

    public getStartDate(): Date {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("lateSignUp")
            ? new Date(this.timeline.inProgress.begin)
            : new Date(0);
    }

    public getNextDate(): Date {
        if (this.state !== "finished" && typeof this.timeline === "object" && this.timeline.hasOwnProperty(this.state)) {
            return new Date(this.timeline[this.state].end);
        }
        return new Date(0);
    }

    /**
     * Return the current league-state
     *
     * @return The league-state
     */
    public getState(): string {
        return this.state;
    }
}
